import * as React from "react";
import { Glyphicon } from "react-bootstrap";
import { TipoReportes } from "../modelo/TiposReporte";

export default class ConsultarReporteXLS extends React.Component<ConsultarReporteXLSProps> {

    render() {
        const { tipoReporte } = this.props;
        return (
            <a className="btns btn-success" onClick={() => this.descargarXLS(tipoReporte)}>
                <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
            </a>
        );
    }

    descargarXLS = (tipo: TipoReportes) => {
        this.props.onDescargar(tipo);
    }

}

interface ConsultarReporteXLSProps {
    tipoReporte: TipoReportes,
    onDescargar: (tipo: TipoReportes) => void;
  }


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/descarga_reporte/componentes/ConsultarReporteXLS.tsx